module.exports = __webpack_public_path__ + "img/icon_btn_copy.39a9f9dd.svg";